import * as globals from '@wandb/weave/common/css/globals.styles';
import {Link} from '@wandb/weave/common/util/links';
// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {IconBack, IconRecentClock} from '@wandb/weave/components/Icon';
// eslint-disable-next-line wandb/no-deprecated-imports
import {Image} from 'semantic-ui-react';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled, {css} from 'styled-components';

import iconEye from '../../../assets/ic-eye.svg';
// @todo: Migrate to 'Skeleton' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Skeleton} from '../../../components/Skeleton';
import {
  cardContent,
  clampStyles,
  skeletonCardContent,
} from './CommonCards.styles';

export const CardContent = styled.div`
  display: flex;
  white-space: nowrap;
  cursor: pointer;
  ${cardContent}
`;
CardContent.displayName = 'S.CardContent';

export const SkeletonCardContent = styled.div`
  display: flex;
  ${skeletonCardContent}
`;
SkeletonCardContent.displayName = 'S.SkeletonCardContent';

export const Card = styled(Link)``;
Card.displayName = 'S.Card';

export const CardImg = styled(Image)`
  border-radius: 8px;
  width: 100px !important;
  height: 100px !important;
`;
CardImg.displayName = 'S.CardImg';

export const CardImageContainer = styled.div`
  display: flex;
  align-items: left;
  margin-right: 10px;
`;
CardImageContainer.displayName = 'S.CardImageContainer';

export const SkeletonCardImg = styled(Skeleton)`
  border-radius: 8px;
  width: 100px;
  height: 100px;
`;
SkeletonCardImg.displayName = 'S.SkeletonCardImg';

export const CardText = styled.div`
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
`;
CardText.displayName = 'S.CardText';

const clampStyles2 = css`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const CardHeader = styled.div`
  ${clampStyles2}
  display: block;
  text-overflow: ellipsis;
  color: ${globals.MOON_950}
  font-family: Source Sans Pro;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;
CardHeader.displayName = 'S.CardHeader';

export const PromptHintBody = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
`;
PromptHintBody.displayName = 'S.PromptHintBody';

export const CardMeta = styled.div`
  margin-top: calc(${globals.spu} * 2);
  display: flex;
  align-items: center;
  color: ${globals.MOON_650};
  font-family: Source Sans Pro;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;
CardMeta.displayName = 'S.CardMeta';

export const ViewsIcon = styled.img.attrs({src: iconEye})`
  margin-left: 12px;
  margin-right: 4px;
`;
ViewsIcon.displayName = 'S.ViewsIcon';

export const BackIcon = styled(IconBack)`
  width: 12px;
  height: 12px;
  margin-right: 4px;
  margin-bottom: 3px;
`;
BackIcon.displayName = 'S.BackIcon';

export const UpdatedAtIcon = styled(IconRecentClock)`
  width: 12px;
  height: 12px;
  margin-right: 4px;
  color: ${globals.GREEN_500};
`;
UpdatedAtIcon.displayName = 'S.UpdatedAtIcon';

export const ClampedLine = styled.span`
  ${clampStyles};
`;
ClampedLine.displayName = 'S.ClampedLine';
